import * as React from "react";
import * as main from "../../main.module.scss";
import * as footer from "./style.module.scss";
export const Footer = () => {
  return (
    <footer className={footer.footer}>
      <div className="container">
        <ul>
          <li>
            <a href="https://vk.com/advanceclub" target="_blank" rel="nofollow, noreferrer">
              <div className={`${main.icon} ${footer.icon}`}>
                <img src="https://fs.advance.ru/landing-pages/icons/social/vk_white.svg" alt="Advance вконтакте"/>
              </div>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/user/advanceclub?sub_confirmation=1" target="_blank" rel="nofollow, noreferrer">
              <div className={`${main.icon} ${footer.icon}`}>
                <img src="https://fs.advance.ru/landing-pages/icons/social/utube_white.svg" alt="Advance на ютуб"/>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};
